var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueryicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 82,
    viewBox: "0 0 91 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71484 70.1891L15.0006 59.4004",
    stroke: "url(#paint0_linear_2213_33527)",
    strokeWidth: 1.77143,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7715 80.8181L26.5143 71.8008",
    stroke: "url(#paint1_linear_2213_33527)",
    strokeWidth: 1.77143,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6582 68.4177L30.0582 57.6289",
    stroke: "url(#paint2_linear_2213_33527)",
    strokeWidth: 1.77143,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4682 70.0736C50.9239 71.0785 50.0923 71.6535 48.9735 71.7985C47.8547 71.9436 46.9254 71.5719 46.1858 70.6833L36.6977 59.2856L51.6303 39.2069L29.1765 50.2506L19.6884 38.8529C18.9488 37.9644 18.7517 36.9832 19.0973 35.9092C19.4428 34.8353 20.1591 34.1217 21.246 33.7686L72.1569 18.2866C73.5351 17.9006 74.6666 18.2391 75.5514 19.302C76.4363 20.3649 76.5612 21.5358 75.9262 22.8145L51.4682 70.0736Z",
    fill: "#9B1E26"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2213_33527",
    x1: 3.58315,
    y1: 61.693,
    x2: 5.2338,
    y2: 67.4406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2213_33527",
    x1: 18.1416,
    y1: 73.717,
    x2: 19.679,
    y2: 78.4138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2213_33527",
    x1: 19.402,
    y1: 59.9215,
    x2: 21.1508,
    y2: 65.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79C9C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryicon);
export default __webpack_public_path__ + "static/media/query icon.2e8566a40f415d620c904afeab9444c2.svg";
export { ForwardRef as ReactComponent };